import type Result from "../core/utils/result";
import { BaseError } from "../core/utils/baseError";

const REQUIRED_CHARACTERS_REGEX = new RegExp(
  '(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[!~<>,;:_=?*+#."&%()|$^@/]).+$',
);
const MAX_PASSWORD_LENGTH = 128;
const MIN_PASSWORD_LENGTH = 12;

const INVALID_CHARACTERS_ERROR =
  "Your password must contain an uppercase, lowercase, number, and special character";
const EXCEEDED_PASSWORD_LENGTH_ERROR = `Your password length must be equal or below ${MAX_PASSWORD_LENGTH}`;
const SUBCEED_PASSWORD_LENGTH_ERROR = `Your password length must be equal or above ${MIN_PASSWORD_LENGTH}`;

const isPasswordCorrect = (password: string): Result<boolean> => {
  if (password.length > MAX_PASSWORD_LENGTH)
    return {
      success: false,
      error: new BaseError(EXCEEDED_PASSWORD_LENGTH_ERROR, {
        context: {
          variable: password,
          maxLength: MAX_PASSWORD_LENGTH,
          message: EXCEEDED_PASSWORD_LENGTH_ERROR,
        },
      }),
    };
  if (password.length < MIN_PASSWORD_LENGTH)
    return {
      success: false,
      error: new BaseError(SUBCEED_PASSWORD_LENGTH_ERROR, {
        context: {
          variable: password,
          minLength: MIN_PASSWORD_LENGTH,
          message: SUBCEED_PASSWORD_LENGTH_ERROR,
        },
      }),
    };
  if (!REQUIRED_CHARACTERS_REGEX.test(password))
    return {
      success: false,
      error: new BaseError(INVALID_CHARACTERS_ERROR, {
        context: {
          variable: password,
          regex: `${REQUIRED_CHARACTERS_REGEX}`,
          message: INVALID_CHARACTERS_ERROR,
        },
      }),
    };
  return { success: true, result: true };
};

export default isPasswordCorrect;
